import { Icon } from '../Icon/Icon';
import { Text, TextTypography } from '../Text/Text';
import { Hidden, NoSsr } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { RoutePath } from 'RoutePath';
import { ReactComponent as MenuIcon } from 'assets/icons/about/burger.svg';
import { ReactComponent as SmallLogoIcon } from 'assets/logo-icon.svg';
import { ReactComponent as MainLogoIcon } from 'assets/logo.svg';
import { useAction } from 'core/store/store';
import { createBrowserHistory } from 'history';
import dynamic from 'next/dynamic';
import React, { useCallback } from 'react';
import i18n from '../../../i18n';
import { makeUserMenuShowAction } from 'state/userMenu/actions';

const UserMenuContainer = dynamic<any>(() => import('MenuContainer').then(mod => mod.MenuContainer), {
    ssr: false,
    loading: () => <></>,
});

const isServer = typeof window === 'undefined';

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 16px',
        marginTop: 20,
        marginBottom: 20,
        [theme.breakpoints.up(375)]: {
            padding: '0 16px',
        },
        [theme.breakpoints.up(479)]: {
            padding: '0 24px',
        },
        [theme.breakpoints.up(767)]: {
            padding: '0 40px',
        },
    },
    icon: {
        display: 'inline-flex',
        cursor: 'pointer',
    },
    logo: {
        maxHeight: 32,
        '&:hover': {
            '-webkit-transform': 'scale(1.2)',
            '-ms-transform': 'scale(1.2)',
            transform: 'scale(1.2)',
        },
    },
    button: {
        marginRight: theme.spacing(2),
    },
    iconBurger: {
        display: 'flex',
        maxHeight: theme.spacing(1.5),
        marginLeft: theme.spacing(5),
        cursor: 'pointer',
        zIndex: 10,
    },
    backButton: {
        cursor: 'pointer',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.fixedPrimary.primary,
        width: theme.spacing(17),
        height: theme.spacing(4),
        borderRadius: theme.spacing(12.5),
    },
    backButtonText: {
        color: `${theme.palette.fixedWhite.primary} !important`,
    },
    right: {
        display: 'flex',
        alignItems: 'center',
    },
}));
export const HeaderBurger = () => {
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    const action = useAction();

    const handleGoToFeedClick = useCallback(() => {
        window.location.assign(RoutePath.FEED);
    }, []);

    const handleSetMapClick = useCallback(() => {
        window.location.assign(RoutePath.FEED);
    }, []);

    const openUserMenu = useCallback(() => action(makeUserMenuShowAction), [action]);

    return (
        <div className={classes.header}>
            <UserMenuContainer isSsr />
            <NoSsr>
                <div className={classes.logo} onClick={handleGoToFeedClick}>
                    <Hidden xsDown>
                        <MainLogoIcon />
                    </Hidden>
                    <Hidden smUp>
                        <SmallLogoIcon />
                    </Hidden>
                </div>
                <div className={classes.right}>
                    <div className={classes.backButton} onClick={handleSetMapClick}>
                        <Text className={classes.backButtonText} typography={TextTypography.PARA_ACCENT}>
                            {t('common:about.back')}
                        </Text>
                    </div>
                    <div className={classes.iconBurger} onClick={() => openUserMenu()}>
                        <Icon color={'#222'} component={MenuIcon} size={32} />
                    </div>
                </div>
            </NoSsr>
        </div>
    );
};
